import { TOGGLE_TABBAR_DYNAMIC_OPTION  } from './actionTypes';

export default (showTabbar) => ({
  type: TOGGLE_TABBAR_DYNAMIC_OPTION,
  payload: {
    showTabbar
  }
});